import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class MultiigrejaProvider {
  baseUrl = environment.API_URL;
  baseAntigaUrl = environment.API_ANTIGA_URL;

  constructor(public http: HttpClient) {}

  getSetorFiltro() {
    return this.http.get<any>(this.baseUrl + '/instituicao/setor-filtro');
  }

  getCidade(idEstado) {
    return this.http.post<any>(this.baseUrl + '/instituicao/cidade', { idEstado: idEstado }).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getEstado() {
    return this.http.get<any>(this.baseUrl + '/instituicao/estado');
  }

  getInstituicaoList(filtro, pag, setor, estado, cidade) {
    return this.http
      .get<any>(this.baseUrl + '/instituicao/instituicao-list', {
        observe: 'response',
        params: {
          page: pag.currentPage,
          'per-page': '10',
          filtro: filtro,
          setor: setor,
          estado: estado,
          cidade: cidade,
        },
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };
        return {
          instituicao: data.body,
          pagination: pag,
        };
      });
  }

  getInstituicaoFilhas(id) {
    return this.http.post<any>(this.baseUrl + '/instituicao/instituicao-filhas', { id: id }).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getLinksUteis(id) {
    return this.http.post<any>(this.baseUrl + '/instituicao/links-uteis', { id: id }).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/multiigreja/multiigreja.ts